import type { Draft } from 'types/graphql'

export type DraftAction =
  | {
      type: 'ADD_EMAIL_RECIPIENT'
      payload: {
        field: 'to' | 'cc' | 'bcc'
        recipient: string
      }
    }
  | {
      type: 'REMOVE_EMAIL_RECIPIENT'
      payload: {
        field: 'to' | 'cc' | 'bcc'
        recipient: string
      }
    }
  | {
      type: 'UPDATE_EMAIL_SUBJECT'
      payload: {
        subject: string
      }
    }
  | {
      type: 'UPDATE_EMAIL_FROM'
      payload: {
        from: string
      }
    }
  | {
      type: 'START_SAVING'
    }
  | {
      type: 'STOP_SAVING'
    }
  | {
      type: 'DEBOUNCE_STARTED'
    }
  | {
      type: 'ERROR_SAVING'
    }
  | {
      type: 'DRAFT_SENT'
    }
  | {
      type: 'PAGE_AI_UNDERWAY'
    }
  | {
      type: 'PAGE_AI_NOT_UNDERWAY'
    }

export type DraftState = {
  draft: Draft
  status: 'idle' | 'dirty' | 'saving' | 'sent' | 'error'
  pageAiUnderway: boolean
}

export const draftReducer = (
  state: DraftState,
  action: DraftAction
): DraftState => {
  switch (action.type) {
    case 'ADD_EMAIL_RECIPIENT':
      return {
        ...state,
        draft: {
          ...state.draft,
          email: {
            ...state.draft.email,
            [action.payload.field]: [
              ...state.draft.email[action.payload.field],
              action.payload.recipient,
            ],
          },
        },
      }
    case 'REMOVE_EMAIL_RECIPIENT':
      return {
        ...state,
        draft: {
          ...state.draft,
          email: {
            ...state.draft.email,
            [action.payload.field]: state.draft.email[
              action.payload.field
            ].filter((recipient) => recipient !== action.payload.recipient),
          },
        },
      }
    case 'UPDATE_EMAIL_SUBJECT':
      return {
        ...state,
        draft: {
          ...state.draft,
          email: {
            ...state.draft.email,
            subject: action.payload.subject,
          },
        },
      }
    case 'UPDATE_EMAIL_FROM':
      return {
        ...state,
        draft: {
          ...state.draft,
          email: {
            ...state.draft.email,
            from: action.payload.from,
          },
        },
      }
    case 'START_SAVING':
      return {
        ...state,
        status: state.status !== 'error' ? 'saving' : 'error',
      }
    case 'STOP_SAVING':
      return {
        ...state,
        status: state.status !== 'error' ? 'idle' : 'error',
      }
    case 'DEBOUNCE_STARTED':
      return {
        ...state,
        status: state.status !== 'error' ? 'dirty' : 'error',
      }
    case 'ERROR_SAVING':
      return {
        ...state,
        status: 'error',
      }
    case 'DRAFT_SENT':
      return {
        ...state,
        draft: {
          ...state.draft,
          status: 'SENT',
        },
      }
    case 'PAGE_AI_UNDERWAY':
      return {
        ...state,
        pageAiUnderway: true,
      }
    case 'PAGE_AI_NOT_UNDERWAY':
      return {
        ...state,
        pageAiUnderway: false,
      }

    default:
      return state
  }
}
